import React from 'react';
import ShareButton, { CreatorInfo as ShareCreatorInfo } from '../common/ShareButton';

export interface ShareSectionProps {
  visible: boolean;
  dataReady: boolean;
  cardId: string | null;
  title: string;
  description: string;
  imageUrl?: string;
  creator?: ShareCreatorInfo | null;
  fallbackCreator?: ShareCreatorInfo | null;
  onCreatorPress?: (id: string) => void;
}

const ShareSection: React.FC<ShareSectionProps> = ({ visible, dataReady, cardId, title, description, imageUrl, creator, fallbackCreator, onCreatorPress }) => {
  if (!visible || !dataReady || !cardId) return null;
  const shareCreator = creator || fallbackCreator || undefined;
  const wrappedOnCreatorPress = onCreatorPress && shareCreator?.id ? () => onCreatorPress(shareCreator.id) : undefined;
  return (
    <ShareButton
      type="card"
      id={cardId}
      title={title}
      description={description}
      imageUrl={imageUrl || ''}
      creator={shareCreator as any}
      showNativeShare={true}
      showCopyLink={true}
      onCreatorPress={wrappedOnCreatorPress}
      containerStyle={{ marginBottom: 0, paddingTop: 12, paddingBottom: 8 }}
    />
  );
};

export default ShareSection;
